import React from "react";
import PropTypes from "prop-types";
import { ProfessionalGuardianPicker } from "../../../../../components/guardian/PrincipalFormComponents";

/**
 * PG directory lookup row (bond principal creation step).
 */
export default function PrincipalPgSection({
  cfg,
  index,
  guardian,
  guardians,
  professionalGuardians,
  loadingGuardians,
  updateGuardianAt,
  selectedPgRecord,
  onPgOptionChange,
  renderExtraBlocks,
}) {
  const clearable = cfg.pgOnChangeUsesUpdateGuardianAt !== true;

  return (
    <>
      <ProfessionalGuardianPicker
        containerSx={cfg.pgLookupBoxSx || undefined}
        options={professionalGuardians}
        value={guardian.professional_guardian}
        loading={loadingGuardians}
        isDisabled={false}
        onSelect={(pgId) => {
          const opt = professionalGuardians.find((p) => p.value === pgId) || null;
          onPgOptionChange(opt);
        }}
        onClear={clearable ? () => onPgOptionChange(null) : undefined}
        onManualEntry={() =>
          updateGuardianAt(index, { showFullForm: true, is_new_pg: true }, guardians)
        }
        selectedPG={selectedPgRecord}
      />
      {renderExtraBlocks?.(index, guardian, guardians)}
    </>
  );
}

PrincipalPgSection.propTypes = {
  cfg: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.arrayOf(PropTypes.object).isRequired,
  professionalGuardians: PropTypes.array.isRequired,
  loadingGuardians: PropTypes.bool.isRequired,
  updateGuardianAt: PropTypes.func.isRequired,
  selectedPgRecord: PropTypes.shape({
    label: PropTypes.string,
    address: PropTypes.string,
    cell: PropTypes.string,
  }),
  onPgOptionChange: PropTypes.func.isRequired,
  renderExtraBlocks: PropTypes.func,
};
